interface Props {
    text: string;
    query: string;
}

const escapeRegExp = (value: string): string => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/** Renders `text` with the first case-insensitive occurrence of `query` wrapped in a `<mark>`. */
export function HighlightedText({ text, query }: Props) {
    const needle = query.trim();
    // Matching on the original text keeps the offsets valid where lowercasing changes the length.
    const match = needle ? new RegExp(escapeRegExp(needle), 'i').exec(text) : null;
    if (!match) return <>{text}</>;

    const start = match.index;
    const end = start + match[0].length;
    return (
        <>
            {text.slice(0, start)}
            <mark className="rounded-sm bg-amber-200 text-inherit">
                {text.slice(start, end)}
            </mark>
            {text.slice(end)}
        </>
    );
}
